<script>
  import { mapGetters, mapActions } from 'vuex'
  // import * as Helper from '@/modules/helper/index'
  import DeviceInfo from '@/modules/util/deviceInfo'
  import moment from 'moment'
  import appconfig from '@/store/modules/appconfig'

  export default {
    data() {
      return {
        nextPageUrl: '',
        loaded: false,
        list: [],
        listdata: [],
        flag: 0
      }
    },
    computed: {
      ...mapGetters([
        'Website',
        'MainMenuLayout',
        'AppConfig',
        'resource'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      ImageUrl() {
        if (this.Website.WebsiteURL !=='' && this.isChangedUrl) {
          this.$showLoader()
          return `${appconfig.state.AppConfig.Urls.WebAPIURL}/api/capture?url=${this.Website.WebsiteURL}`
        }
      },
      // ShowWebUrl() {
      //   return Helper.IsDevSim()
      // }
    },
    watch: {
      Website: async function(value, oldvalue) {
        if (value !== oldvalue) {
          this.isChangedUrl = true
        } else {
          this.isChangedUrl = false
        }
      }
    },
    created() {
      this.initWebsite(this.SubscriptionModuleId)
    },
    mounted() {
      if (this.$refs.Website) {
        this.$refs.Website.$on('page:reinit', (event, payload) => {
          this.initWebsite(this.SubscriptionModuleId)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.Website) {
        this.$refs.Website.$off('page:reinit', (event, payload) => {
          this.initWebsite(this.SubscriptionModuleId)
        })
      }
    },
    methods: {
      ...mapActions([
        'loadLocalWebsite',
        'loadWebsite'
      ]),
      async initWebsite(SubscriptionModuleId) {
        this.loadLocalWebsite(SubscriptionModuleId)
        this.loadWebsite(SubscriptionModuleId).then(async () => {
          this.$RegisterPageView({
            'SubscriptionModule_Id': SubscriptionModuleId,
            'ContentGUID': 'this.Website.Id',
            'ViewType': 1
          })
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      clickHandle() {
        let modalOptions = {
          title: this.resource.warningTitle,
          text: this.resource.warningMessage,
          buttonText: this.resource.closeBtn,
          downloadbuttonText: DeviceInfo.isAndroid ? this.resource.AndroidDownload : this.resource.AppleDownload,
          $f7: this.$f7
        }
        this.$showModal(modalOptions)
      },
      onLoaded() {
      this.loaded = true;
      this.$hideLoader()
     }
    }
  }
</script>
<template>
  <f7-page ref="Website" :page-content="false" name="website-view">
    <app-header :header="Website.PageTitle"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <f7-page-content class="no-scroll" v-if="Website.WebsiteURL !== 'https://' && Website.WebsiteURL !== 'http://'" >
      <img :src="ImageUrl"  v-on:load="onLoaded" v-show="loaded" width="298" @click="clickHandle" />
    </f7-page-content>
    <!-- <f7-page-content v-else>
      <f7-block strong inset>
        <p>{{resource.nowebsitedata}}</p>
      </f7-block>
    </f7-page-content> -->
  </f7-page>
</template>
<style scoped> 
  .no-scroll {
    overflow: hidden!important;
  }
 </style>



// WEBPACK FOOTER //
// src/components/website/website.vue